module.exports = __webpack_public_path__ + "img/bg (4).592a9930.jpg";